// extracted by mini-css-extract-plugin
export default {"infoBox":"Info__infoBox-mtVp","textBox":"Info__textBox-qsSt","outer":"Info__outer-QSQA","reverse":"Info__reverse-hdMB"};